// extracted by mini-css-extract-plugin
export default {"titleTable":"TransferCredits_titleTable__ubScm","row":"TransferCredits_row__2Bx4A"};